import { Capacitor } from '@capacitor/core';

/**
 * Returns true when the app is running inside a native Capacitor shell (Android/iOS).
 * In a regular web browser this will always return false.
 */
export const isNativeApp = (): boolean => {
  return Capacitor.isNativePlatform();
};
